import React from 'react';

const IFSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.8245 15H1.17549C1.07848 15 1 14.9215 1 14.8245V1.17549C1 1.07848 1.07848 1 1.17549 1H14.8245C14.9215 1 15 1.07848 15 1.17549V14.8245C15 14.9215 14.9215 15 14.8245 15ZM1.35097 14.649H14.649V1.35097H1.35097V14.649ZM4.17584 10.3866H5.62653V7.43844H4.17584V6.90028H6.25049V10.3866H7.60759V10.9248H4.17584V10.3866ZM5.93851 6.01114C5.7562 6.01114 5.62897 5.97361 5.55634 5.89805C5.4837 5.82298 5.44714 5.72792 5.44714 5.61337V5.48858C5.44714 5.37402 5.48322 5.27946 5.55634 5.2039C5.62946 5.12834 5.75668 5.09081 5.93851 5.09081C6.12033 5.09081 6.24756 5.12834 6.32068 5.2039C6.39331 5.27946 6.42987 5.37402 6.42987 5.48858V5.61337C6.42987 5.72792 6.39331 5.82298 6.32068 5.89805C6.24805 5.97361 6.12082 6.01114 5.93851 6.01114ZM8.64004 10.3866H9.99714V7.43844H8.56205V6.90028H9.99714V6.07354C9.99714 5.80348 10.0683 5.58217 10.2116 5.41058C10.3549 5.239 10.5797 5.1532 10.8863 5.1532H12.2356V5.69136H10.6211V6.90028H12.2356V7.43844H10.6211V10.3866H12.0562V10.9248H8.64004V10.3866Z"
        fill={color}
        stroke={color}
        strokeWidth="0.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IFSVG;
